"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSpecificServiceAgreements = exports.GetConsumerExpiredServiceAgreements = exports.GetIndexerExpiredServiceAgreements = exports.GetExpiredServiceAgreements = exports.GetConsumerOngoingServiceAgreements = exports.GetIndexerOngoingServiceAgreements = exports.GetOngoingServiceAgreements = exports.GetConsumerServiceAgreementsCount = exports.GetIndexerServiceAgreementsCount = exports.ServiceAgreementFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ServiceAgreementFields = (0, graphql_tag_1.default) `
  fragment ServiceAgreementFields on ServiceAgreement {
    id
    deploymentId
    indexerAddress
    consumerAddress
    period
    lockedAmount
    startTime
    endTime
    deployment {
      id
      version
      project {
        id
        metadata
      }
    }
  }
`;
exports.GetIndexerServiceAgreementsCount = (0, graphql_tag_1.default) `
  query GetIndexerServiceAgreementsCount($address: String!) {
    serviceAgreements(filter: { indexerAddress: { equalTo: $address } }) {
      totalCount
    }
  }
`;
exports.GetConsumerServiceAgreementsCount = (0, graphql_tag_1.default) `
  query GetConsumerServiceAgreementsCount($address: String!) {
    serviceAgreements(filter: { consumerAddress: { equalTo: $address } }) {
      totalCount
    }
  }
`;
exports.GetOngoingServiceAgreements = (0, graphql_tag_1.default) `
  query GetOngoingServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: {
        or: [{ indexerAddress: { equalTo: $address } }, { consumerAddress: { equalTo: $address } }]
        endTime: { greaterThanOrEqualTo: $now }
      }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetIndexerOngoingServiceAgreements = (0, graphql_tag_1.default) `
  query GetIndexerOngoingServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: { indexerAddress: { equalTo: $address }, endTime: { greaterThanOrEqualTo: $now } }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetConsumerOngoingServiceAgreements = (0, graphql_tag_1.default) `
  query GetConsumerOngoingServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: { consumerAddress: { equalTo: $address }, endTime: { greaterThanOrEqualTo: $now } }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetExpiredServiceAgreements = (0, graphql_tag_1.default) `
  query GetExpiredServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: {
        or: [{ indexerAddress: { equalTo: $address } }, { consumerAddress: { equalTo: $address } }]
        endTime: { lessThan: $now }
      }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetIndexerExpiredServiceAgreements = (0, graphql_tag_1.default) `
  query GetIndexerExpiredServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: { indexerAddress: { equalTo: $address }, endTime: { lessThan: $now } }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetConsumerExpiredServiceAgreements = (0, graphql_tag_1.default) `
  query GetConsumerExpiredServiceAgreements($address: String!, $now: Datetime!) {
    serviceAgreements(
      filter: { consumerAddress: { equalTo: $address }, endTime: { lessThan: $now } }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
exports.GetSpecificServiceAgreements = (0, graphql_tag_1.default) `
  query GetSpecificServiceAgreements($deploymentId: String!, $now: Datetime!) {
    serviceAgreements(
      filter: { deploymentId: { equalTo: $deploymentId }, endTime: { lessThan: $now } }
      orderBy: END_TIME_ASC
    ) {
      totalCount
      nodes {
        ...ServiceAgreementFields
      }
    }
  }
  ${exports.ServiceAgreementFields}
`;
//# sourceMappingURL=agreements.generated.js.map